import React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"

import ProductHeader from "../components/productheader"
import ProductSection from "../components/productsection"
import SPSMOne from "../images/sp_sm_1.jpg"
import SPSMTwo from "../images/sp_sm_2.jpg"

const SpSponsorme = () => (
  <Layout>
    <SEO title="Samritan's Purse Sponsor Me" />
    <div className="relative max-w-screen-lg mx-auto">
      <ProductHeader
        title="Samaritan's Purse Sponsor Me"
        subtitle="Front-end | Design"
      />
      <ProductSection image={SPSMOne} />
      <ProductSection image={SPSMTwo} />
    </div>
  </Layout>
)

export default SpSponsorme
